import {
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';

// Ideally, we would just extend the <select /> element and not require any changes to the markup,
// but was unable to get to this. Instead, any <select /> needs to be wrapped in an <ap-select> element.
@Component({
  selector: 'ap-select',
  templateUrl: './ap-select.component.html',
})
export class ApSelectComponent implements OnInit {
  @ViewChild('apSelectElement', { static: true }) hostElement: ElementRef;

  constructor(
    private renderer: Renderer2,
  ) { }

  ngOnInit(): void {
    const element = this.hostElement.nativeElement as Element;
    this.setupApSelect(element);
  }

  private setupApSelect(element: Element) {
    // Only add input-group class if it has 'input-group-addon' or 'input-group-btn'.
    const isInputGroup = element.querySelector('.input-group-btn,.input-group-addon') != null;
    if (isInputGroup) {
      for (let i = 0; i < element.children.length; i++) {
        const child = element.children.item(i);
        this.renderer.addClass(child, 'input-group');
      }
    }

    const selectElement = element.querySelector('select:not(.native)');
    if (selectElement != null) {
      this.renderer.addClass(selectElement.parentElement, 'has-feedback');
      const iconElement = this.renderer.createElement('span');
      this.renderer.addClass(iconElement, 'form-control-feedback');
      const chevronElement = this.renderer.createElement('span');
      this.renderer.addClass(chevronElement, 'ap-chevron-down-gray');

      this.renderer.appendChild(iconElement, chevronElement);
      this.renderer.insertBefore(selectElement.parentElement, iconElement, selectElement);
    }
  }
}
